import { render } from "./PaiementMethodePage.vue?vue&type=template&id=e825b904&ts=true"
import script from "./PaiementMethodePage.vue?vue&type=script&lang=ts"
export * from "./PaiementMethodePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__